export const MODAL_SIZE = {
  s: {
    maxWidth: '580px',
    maxHeight: '760px',
  },
  m: {
    maxWidth: '700px',
    maxHeight: '760px',
  },
  l: {
    maxWidth: '880px',
    maxHeight: '760px',
  },
  xl: {
    maxWidth: '1200px',
    maxHeight: '760px',
  },
}
